import { supabase } from '@/integrations/supabase/client';
import { AD_PAGES, pageKey } from '@/lib/adPages';

export const ADS_KEY = 'ads_config';
export const AD_BUCKET = 'ad-images';

export interface AdsConfig {
  enabled: boolean;
  hiddenPages: string[];
  imagePath: string | null;
  link: string;
  /** Subscription amount in ₹; when > 0 tapping the ad opens PhonePe with the store UPI ID. */
  payAmount?: number;
  /** Optional contact phone number shown as a call button under the ad. */
  phone?: string;
}
export const DEFAULT_ADS: AdsConfig = { enabled: false, hiddenPages: ['/exam'], imagePath: null, link: '' };

export { AD_PAGES, pageKey };

export function adsAllowed(cfg: AdsConfig, pathname: string): boolean {
  return cfg.enabled && !cfg.hiddenPages.includes(pageKey(pathname));
}

export function parseAds(value: unknown): AdsConfig {
  try {
    const v = typeof value === 'string' ? JSON.parse(value) : value;
    if (v && typeof v === 'object') return { ...DEFAULT_ADS, ...(v as any) };
  } catch { /* ignore */ }
  return DEFAULT_ADS;
}

export async function fetchAdsConfig(): Promise<AdsConfig> {
  const { data } = await supabase.from('app_settings').select('value').eq('key', ADS_KEY).maybeSingle();
  return data ? parseAds(data.value) : DEFAULT_ADS;
}

export async function adImageUrl(path: string): Promise<string | null> {
  const { data } = await supabase.storage.from(AD_BUCKET).createSignedUrl(path, 60 * 60 * 24);
  return data?.signedUrl ?? null;
}
